export const THEME = {
  DARK: 'dark',
  LIGHT: 'light',
};

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const COMPETITOR_TYPE = {
  NARROW: 'NARROW',
  BROAD: 'BROAD',
  ALL: 'ALL',
};

export const VIEWS = {
  NARROW: COMPETITOR_TYPE.NARROW,
  BROAD: COMPETITOR_TYPE.BROAD,
  ALL: COMPETITOR_TYPE.ALL,
  GROUPS: 'Groups',
  TOP_10: 'Top_10',
  TOP_20: 'Top_20',
  FOCUS: 'Focus',
};

export const SONAR_SECTIONS = {
  INTEREST: 'interest',
  TRUST: 'trust',
  FRICTION: 'friction',
  PASSION: 'passion',
  RELEVANCE: 'relevance',
  FOOTPRINT: 'footprint',
  BRAND: 'brand',
};

export const TREND_GROUPS = {
  TREND_POSITIVE: 1,
  TREND_NEUTRAL: 0,
  TREND_NEGATIVE: -1,
};

export const TREND_COLORS = {
  [TREND_GROUPS.TREND_POSITIVE]: 'rgba(18, 187, 75)',
  [TREND_GROUPS.TREND_NEUTRAL]: 'rgba(54, 116, 255)',
  [TREND_GROUPS.TREND_NEGATIVE]: 'rgba(244, 51, 24)',
};

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹])/;

export const COMMON_PAGE_SIZE_OPTIONS = [
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 50,
    label: '50',
  },
];

export const USER_ROLES = {
  GLOBAL_ADMIN: 'ROLE_GLOBAL_ADMIN',
  GLOBAL_USER: 'ROLE_GLOBAL_USER',
  COMPANY_ADMIN: 'ROLE_COMPANY_ADMIN',
  COMPANY_USER: 'ROLE_COMPANY_USER',
  ROLE_CUSTOMER: 'ROLE_CUSTOMER',
};

export const CONTENT_VIEW = {
  TABLE: 'TABLE',
  CARDS: 'CARDS',
};

export const PROJECT_TYPES = {
  SONAR: 'SONAR',
  RESONANCE: 'RESONANCE',
  SCOUTV2: 'SCOUTV2',
  GENIE: 'GENIE',
  GENIE_GO: 'GENIE2GO',
  ID8: 'ID8',
  ACTIV8: 'ACTIV8',
};

export const PROJECT_TYPES_API = {
  [PROJECT_TYPES.SONAR]: 'sonar',
  [PROJECT_TYPES.RESONANCE]: 'resonance',
  [PROJECT_TYPES.SCOUTV2]: 'scout-v2',
  [PROJECT_TYPES.GENIE]: 'genie',
  [PROJECT_TYPES.GENIE_GO]: 'genie2go',
  [PROJECT_TYPES.ID8]: 'id8',
  [PROJECT_TYPES.ACTIV8]: 'activ8',
};

export const PROJECT_TYPES_ROUTES = {
  [PROJECT_TYPES.SONAR]: 'sonar',
  [PROJECT_TYPES.RESONANCE]: 'resonance',
  [PROJECT_TYPES.SCOUTV2]: 'scout',
  [PROJECT_TYPES.GENIE]: 'genie',
  [PROJECT_TYPES.GENIE_GO]: 'genie-go',
  [PROJECT_TYPES.ID8]: 'id8',
  [PROJECT_TYPES.ACTIV8]: 'activ8',
};

export const RESONANCE_THEMES = {
  FACTIVE: 'FACTIVE',
  HACKABU: 'HACKABU',
};

export const RESONANCE_VISIONS = {
  DEFAULT: 'DEFAULT',
  TOP_EXTRA_CORRELATION: 'TOP_EXTRA_CORRELATION',
};

export const RESONANCE_STRUCTURE = {
  MESSAGES: 'MESSAGES',
  RESPONDENTS: 'RESPONDENTS',
};

export const MAX_SNACKS = 3;

export const LANGUAGES = {
  ENGLISH: 'English',
  GERMAN: 'German',
  DANISH: 'Danish',
};

export const LANGUAGES_SHORT = {
  ENGLISH: 'en',
  GERMAN: 'de',
};

export const SCOUT_SETTINGS_FILTER = {
  WRITER: 'WRITER',
  TEXT_LENGTH: 'TEXT_LENGTH',
};

export const WRITERS_STATUS = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
};

export const REACTIONS = {
  LIKE: 'LIKE',
};

export const AUDIENCE_TYPES = {
  B2C: 'B2C',
  B2B: 'B2B',
};

export const TEXT_LENGTH = {
  SHORT: 'SHORT',
  ELABORATED: 'ELABORATED',
};

export const SCOUT_TABS = {
  ALL_MESSAGES: 0,
  SELECTED_MESSAGES: 1,
  FINAL_MESSAGES: 2,
  SCREENED_MESSAGES: 3,
  BACKUP: 4,
};

export const ID8_TABS = {
  IDEAS: 0,
  IMAGES: 1,
  RECREATE: 2,
  LIKED: 3,
  BACKUP: 4,
};

export const SONAR_TABS = {
  DASHBOARD: 0,
  NAVIG8: 1,
  POWERRANK: 2,
  DATA: 3,
  INTEREST: 4,
  RELEVANCE: 5,
  TRUST: 6,
  ENGAGEMENT: 7,
  RIVALRY: 8,
  PRESENCE: 9,
  BRAND: 10,
};

export const EMPTY_DROPDOWN_OPTION = { value: '', label: '' };

export const MODAL_TYPES = {
  DELETE: 'DELETE',
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  CONFIRMATION: 'CONFIRMATION',
  INFO: 'INFO',
};

export const PROJECTS_LIST_SIZE_OPTIONS = [
  {
    value: 12,
    label: '12',
  },
  {
    value: 24,
    label: '24',
  },
  {
    value: 60,
    label: '60',
  },
];

export const LIGHT_CHART_COLORS = ['#3674FF', '#C25AE8', '#FFCA00', '#12BB4B', '#1B4CBB', '#FFA013'];

export const DARK_CHART_COLORS = ['#3962BA', '#E8845A', '#6493FF', '#248D4E', '#12B1BB', '#FFA013'];

export const MONTHS = {
  JANUARY: 'JANUARY',
  FEBRUARY: 'FEBRUARY',
  MARCH: 'MARCH',
  APRIL: 'APRIL',
  MAY: 'MAY',
  JUNE: 'JUNE',
  JULY: 'JULY',
  AUGUST: 'AUGUST',
  SEPTEMBER: 'SEPTEMBER',
  OCTOBER: 'OCTOBER',
  NOVEMBER: 'NOVEMBER',
  DECEMBER: 'DECEMBER',
};

export const ADD_DATASET_TABS = {
  GENERAL: 0,
  SOCIAL: 1,
  PROJECT_SETTINGS: 2,
};

export const EXTENDED_CHART_TYPES = {
  BUBBLES: 'bubbles',
  SCATTER: 'scatter',
};

export const RELEVANCE_ALL_VIEWS = {
  TOP_10_RELEVANCE_BREADTH: 'TOP_10_RELEVANCE_BREADTH',
  TOP_10_RELEVANCE_STRENGTH: 'TOP_10_RELEVANCE_STRENGTH',
  TOP_20_RELEVANCE_BREADTH: 'TOP_20_RELEVANCE_BREADTH',
  TOP_20_RELEVANCE_STRENGTH: 'TOP_20_RELEVANCE_STRENGTH',
};

export const FOOTPRINT_ALL_VIEWS = {
  TOP_10_PRESENCE: 'TOP_10_PRESENCE',
  TOP_10_ENERGY: 'TOP_10_ENERGY',
  TOP_20_PRESENCE: 'TOP_20_PRESENCE',
  TOP_20_ENERGY: 'TOP_20_ENERGY',
};

export const URL_STATUSES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const CRAWL_PROJECT_STATUS = {
  EXECUTE: 'EXECUTE',
  EXECUTED: 'EXECUTED',
  EXECUTING: 'EXECUTING',
  CANCELED: 'CANCELED',
};

export const SONAR_RANGE_TYPE = {
  COMPARABLE: 'COMPARABLE',
  COMPARE_TO: 'COMPARE_TO',
};

export const SONAR_PROGRESS_TYPE = {
  CRAWL: 'CRAWL',
  COLLECT_SONAR: 'COLLECT_SONAR',
};

export const ASSISTANT_TYPES = {
  FILE: 'FILE',
  TEXT: 'TEXT',
};

export const AI_CHATS = {
  OPEN_AI: 'OPEN_AI',
  ANTHROPIC: 'ANTHROPIC',
  GEMINI: 'GEMINI',
  PERPLEXITY: 'PERPLEXITY',
};

export const AI_MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
};

export const PLAYGROUND_TYPES = {
  ASSISTANTS: ASSISTANT_TYPES,
  AI_CHATS: AI_CHATS,
  MEDIA: AI_MEDIA_TYPES,
};

export const MARKETS = {
  DK: 'DK',
  S: 'S',
  NO: 'NO',
  AUST: 'AUST',
  D: 'D',
};

export const GENDERS = {
  ALL: 'ALL',
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER',
};

export const SCOUT_CREATE_TYPE = {
  GENERATED: 'GENERATED',
  COMPRESSED: 'COMPRESSED',
};

export const ASSISTANTS_CATEGORY = {
  COMPRESS: 'COMPRESS',
  GENERATE_ALL: 'GENERATE_ALL',
  GENERATE_SELECTED: 'GENERATE_SELECTED',
  SONAR_AZ: 'SONAR_AZ',
  CUSTOM: 'CUSTOM',
};

export const SCOUT_ASSISTANTS_CATEGORY = [
  ASSISTANTS_CATEGORY.GENERATE_ALL,
  ASSISTANTS_CATEGORY.GENERATE_SELECTED,
  ASSISTANTS_CATEGORY.COMPRESS,
];

export const mapScoutTabsToAssistantCategories = {
  [SCOUT_TABS.ALL_MESSAGES]: ASSISTANTS_CATEGORY.GENERATE_ALL,
  [SCOUT_TABS.SELECTED_MESSAGES]: ASSISTANTS_CATEGORY.GENERATE_SELECTED,
  [SCOUT_TABS.FINAL_MESSAGES]: ASSISTANTS_CATEGORY.COMPRESS,
  [SCOUT_TABS.SCREENED_MESSAGES]: '',
};

export const SONAR_PROJECT_RANGE_TYPE = {
  DAILY_RANGE: 'DAILY_RANGE',
  MONTHLY_RANGE: 'MONTHLY_RANGE',
};

export const RESONANCE_TABS = {
  BACKGROUND_DATA: 0,
  MESSAGE_RESPONSE: 1,
  CONCEPT_RESPONSE: 2,
  BENCHMARKS: 3,
};

export const RESONANCE_GENERIC_TYPES = ['Question', 'BG'];

export const RESONANCE_SORT = {
  TOTAL_MESSAGE: 'TOTAL_MESSAGE',
  TOTAL_R1: 'TOTAL_R1',
  TOTAL_R2: 'TOTAL_R2',
  TOTAL: 'TOTAL',
  R1: 'R1',
  R2: 'R2',
};

export const PERFORMING_AUDIENCES_COLUMNS = ['Sex', 'Age', 'Region'];

export const RESONANCE_MESSAGES_LIST_SIZE = [
  {
    value: 5,
    label: '5',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
];

export const SCOUT_VARIATION_SCORES = [
  { value: 'NARROW_VARIATION', label: 'narrowVariation' },
  { value: 'BROAD_VARIATION', label: 'broadVariation' },
  { value: 'ALL_TOPICS', label: 'allTopics' },
];

export const SCOUT_VARIATION_LIST = [
  { value: 'CONSIDER_TOPICS', label: 'considerTopics' },
  { value: 'CONSIDER_EXPRESSION', label: 'considerExpression' },
];

export const GENIE_EVALUATE_TYPE = {
  ALTERNATE: 'ALTERNATE',
  GENERATED: 'GENERATED',
};

export const PROJECT_VARIANTS = {
  ADMIN: 'ADMIN',
  CONSUMER: 'CONSUMER',
};

export const AGENT_TYPES = {
  SYSTEM: 'SYSTEM',
  CUSTOM: 'CUSTOM',
};

export const RESONANCE_CONCEPT_DATA_TYPES = {
  ORIGINAL: 'original',
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
};

export const PLAYGROUND_RESPONSE_TYPES = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
};

export const ID8_GEN_TYPES = {
  IDEAS: 'IDEAS',
  IMAGES: 'IMAGES',
  LIKED: 'LIKED',
  RECREATE: 'RECREATE',
};

export const PROMPT_TYPE = {
  IDEA: 'IDEA',
  RECREATE: 'RECREATE',
};

export const MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  APPLICATION: 'APPLICATION',
};

export const MEDIA_CONTENT_PLACEMENT = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
};

export const ACTIV8_TABS = {
  FIND: 0,
  STUDIO: 1,
  MESSAGES: 2,
  STORY: 3,
};

export const ACTIV8_CONTENT_STATUS = {
  ONLINE: 'ONLINE',
  DELETED: 'DELETED',
  EXPIRED: 'EXPIRED',
};

export const ACTIV8_MESSAGE_TABS = {
  GENERATE: 0,
  ADJUST: 1,
};

export const ACTIV8_SETTINGS_TABS = {
  ARCHIVE: 0,
};

export const ACTIV8_MESSAGE_GENERATE_TABS = {
  GENERATED: 0,
  SAVED: 1,
};

export const AI_STUDIO_TABS = {
  GENERATED: 0,
  FAVORITES: 1,
};

export const MEDIA_UPLOAD_STATUS = {
  PENDING: 'PENDING',
  UPLOADING: 'UPLOADING',
  SUCCES: 'SUCCESS',
  FAILED: 'FAILED',
};

export const MEDIA_CONVERT_STATUS = {
  PENDING: 'PENDING',
  CONVERTING: 'CONVERTING',
  CONVERTED: 'CONVERTED',
  FAILED: 'FAILED',
};

export const AI_STUDIO_FIELDS = {
  FILE: 'FILE',
  TEXT: 'TEXT',
  CONVERT: 'CONVERT',
  CHAT: 'CHAT',
  DROPDOWN: 'DROPDOWN',
  SWITCH: 'SWITCH',
};

export const AI_STUDIO_ADAPTERS = {
  ACTIV8: 'ACTIV8',
  ID8: 'ID8',
  FILE: 'FILE',
};

export const CUSTOM_BUCKET_ID = 'CUSTOM_BUCKET_ID';

export const AI_STUDIO_SCOPES = {
  PROJECT: 'PROJECT',
  USER: 'USER',
  DEMO: 'DEMO',
};

export const AI_STUDIO_STORE_OPERATIONS = {
  NEW_CONTENT: 'NEW_CONTENT',
  ADD_TO_BUCKET: 'ADD_TO_BUCKET',
};

export const STORY_SCOPES = {
  ACTIV8: 'ACTIV8',
};

export const STORY_SOURCES = {
  ACTIV8_CONTENT: 'ACTIV8_CONTENT',
  STUDIO_FAVORITE: 'STUDIO_FAVORITE',
  MESSAGE: 'MESSAGE',
};

export const STORY_PLATFORM_TYPES = {
  LINKEDIN: 'LINKEDIN',
  YOUTUBE: 'YOUTUBE',
  META: 'META',
  BANNERS: 'BANNERS',
  OTHER_SOCIALS: 'OTHER_SOCIALS',
  LONG_FORM: 'LONG_FORM',
};

export const STORY_GENERATED_CONTENT_STATUS = {
  PENDING: 'PENDING',
  READY: 'READY',
};

export const STORY_GENERATED_CONTENT_SUBTYPE = {
  PNG: 'PNG',
  MP4: 'MP4',
};
